export default __webpack_public_path__ + "static/media/gallery_06.4d6002e2.jpg";